import React, { Suspense } from 'react';
import cx from 'classnames';
import { IKImage } from 'imagekitio-react';
import { getContentForFieldSelector } from './fields';
import Content from '../widgets/core/content';

const DefaultViewer = React.lazy(
  () => import('@paperflite-marketing/asset-viewer').then(module => ({ default: module.DefaultViewer }))
);

import styles from './assetviewer.module.scss';


export const DefaultAssetViewer = ({ asset, isDarkMode=false, lightBox=false, active, onAnalyticsChange, onDebugAnalytics }) => {
  const contentContext = React.useContext(Content.Context);

  const icon = getContentForFieldSelector(asset, 'icon');
  const iconUrl = _.get(icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
  const downloadUrl = _.get(asset, 'content.asset.downloadUrl');

  const handleDownload = (asset) => {
    window.open(downloadUrl, "_blank");
    contentContext.onDownload(asset);
  }

  return (
    <Suspense fallback={<div className={styles.defaultViewer}></div>}>
      <DefaultViewer className={styles.defaultViewer}
        active={active}
        onAnalyticsChange={onAnalyticsChange}
        onDebugAnalytics={onDebugAnalytics}
      >
        <div className={styles.inner}>
          <div className={styles.icon}>
            <IKImage path={iconUrl} width={400} height={226.75} />
          </div>
          {downloadUrl &&
            <React.Fragment>
              <div className={cx(styles.message, {[isDarkMode? styles.darkMessage : styles.lightMessage]: lightBox})}>
                Click below to download the file
              </div>
              <a onClick={handleDownload} 
                className={cx(styles.downloadButton, {[isDarkMode? styles.darkDownloadButton : styles.lightDownloadButton]: lightBox})} 
                target="_blank"
              >
                Download
              </a>
            </React.Fragment>
          }

          {!downloadUrl &&
            <div className={cx(styles.message, {[isDarkMode? styles.darkMessage : styles.lightMessage]: lightBox})}>
              Unable to preview the asset
            </div>
          }
        </div>
      </DefaultViewer>
    </Suspense>
  );
}
